import { render, staticRenderFns } from "./WebPartFormShopDesigner.vue?vue&type=template&id=8c513462&"
import script from "./WebPartFormShopDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormShopDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports